import React from "react";
import { dialog, Button } from "nq-component";
import Table from "../../../components/Table";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../usecases/object";
import { InfiniteScroll } from "nq-component";
import withRouter from "../../../withRouter";
import Search from "../../../components/Search";
import BaseListPage from "../../../base/BaseListPage";
import CardView from "../../../components/common/CardView";
import BatchJobsPresenter from "./BatchJobsPresenter";
import { FloatingForm } from "../../../components/common/Converter";
import Progress from "../../../components/Progress";

class BatchJobsPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new BatchJobsPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase()
    );
    this.state = {
      objects: [],
      object: {},
      isViewEnable: false,
      count: 0,
      limit: 10,
      current: 1,
    };
  }

  getCollectionName() {
    return "batch_jobs";
  }

  async refetchData() {
    const objects = await this.presenter.getObjects();
    this.filterSubmit({});
    return objects;
  }

  onClickPagination(page) {
    this.presenter.setCurrentPage(page);
  }

  setObjects(objects) {
    this.setState({ objects });
  }

  setCurrent(current) {
    this.setState({ current });
  }

  handleOnRunBatch() {
    dialog.fire({
      html: (
        <>
          <div className="row p-2">
            <h4>Confirmation</h4>
            <hr />
            <p style={{ fontSize: "13px", padding: "1rem" }}>
              Do you want to run a batch ?
            </p>
            <hr />
          </div>

          <div className="w-100 d-flex justify-content-end gap-4 pe-3 pb-3">
            <Button
              className="btn btn-light fs-sm"
              onClick={() => dialog.close()}
            >
              Cancel
            </Button>
            <Button
              className="btn btn-primary"
              // onClick={this.confirmChanges.bind(this)}
            >
              Confirm
            </Button>
          </div>
        </>
      ),
      footer: false,
    });
  }

  handleViewData(object) {
    this.setState({ object, isViewEnable: true });
  }

  tableData(header, data) {
    return (
      <tr>
        <td style={{ backgroundColor: "#d3d3d3", width: "50%" }}>{header}</td>
        <td className="ps-3">{data}</td>
      </tr>
    );
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const { objects, loading, object, count, limit, current } = this.state;
    if (!schema) return <Progress />;
    // const user = this.getCurrentUser();
    return (
      <>
        <div className="overflow-auto" style={{ marginTop: "5rem" }}>
          <InfiniteScroll
            className="h-100"
            loadMore={this.loadMore.bind(this)}
            // hasMore={!progress && count > objects.length}
          >
            <div className="p-3 p-lg-4">
              <div
                className="d-flex mb-4"
                style={{ borderBottom: "1.5px solid #d3d3d3" }}
              >
                <p style={{ fontSize: ".9rem", color: "rgba(0, 0, 0, .45)" }}>
                  You are here: Home {">"} System Administration {">"}{" "}
                  <span
                    style={{ fontSize: "1rem", color: "rgba(0, 0, 0, .70)" }}
                  >
                    {schema.label}
                  </span>
                </p>
              </div>
              <CardView style={{ borderRadius: 0 }}>
                <Search
                  schemas={this.getSchemas()}
                  placeholder="Search ID"
                  onSubmit={this.searchSubmit.bind(this)}
                  fields={schema.fields}
                />
              </CardView>

              <div
                style={{
                  marginTop: "20px",
                  width: "100%",
                }}
              >
                <CardView style={{ borderRadius: 0 }}>
                  <div className="d-flex align-items-center">
                    <h4 className="text-primary">{schema.label}</h4>
                    <div style={{ marginLeft: "auto" }}>
                      <Button onClick={this.handleOnRunBatch.bind(this)}>
                        Run Batch
                      </Button>
                    </div>
                  </div>
                </CardView>
              </div>

              <Table
                progress={loading}
                objectData={this.handleViewData.bind(this)}
                refetch={this.refetchData.bind(this)}
                fields={schema.fields}
                objects={objects}
                collection={schema}
                count={count}
                limit={limit}
                current={current}
                loadPagination={this.onClickPagination.bind(this)}
                actionsList={[
                  {
                    label: <i className="bi bi-search"> View</i>,
                    actionType: "object",
                  },
                ]}
                // selectable
                // collapsable
                excludeFields={Object.keys(schema.fields).reduce(
                  (acc, key) => {
                    const options = schema.fields[key];
                    if (options.read === false) {
                      acc.push(key);
                    }
                    switch (options._type || options.type) {
                      case "Relation":
                      case "Array":
                      case "Object":
                      case "File":
                        acc.push(key);
                        break;
                      default:
                    }
                    return acc;
                  },
                  ["id", "Created At", "Updated At"]
                )}
                // selected={selected}
                // onSelect={this.onSelect.bind(this)}
                // onSelectAll={this.onSelectAll.bind(this)}
                // progress={progress}
                onClickItem={this.onClickItem.bind(this)}
              />
            </div>
          </InfiniteScroll>
          {this.state.isViewEnable && (
            <FloatingForm width="30rem">
              <CardView style={{ padding: 0 }}>
                <h4 className="fs-6 fw-bold pt-3 ps-3">Job{object.batchId} </h4>
                {/* <hr /> */}
                <div className="p-2">
                  <table className="table table-bordered">
                    <tbody>
                      {this.tableData("ID:", object.batchId)}
                      {this.tableData("Date Started:")}
                      {this.tableData("Date Ended:")}
                      {this.tableData("Period:")}
                      {this.tableData("Status:")}
                    </tbody>
                  </table>
                </div>

                <div className="w-100 d-flex justify-content-end gap-4 mb-3 pe-3">
                  <button
                    className="btn btn-light"
                    type="button"
                    onClick={() => this.setState({ isViewEnable: false })}
                  >
                    Cancel
                  </button>
                </div>
              </CardView>
            </FloatingForm>
          )}
        </div>
      </>
    );
  }
}

export default withRouter(BatchJobsPage);
